import { Flex, Td, Text, Tr } from '@chakra-ui/react';
import { OrderWithDeliveryOrders } from '@diamond/shared/types';
import { BindedPromoData } from '@diamond/sol-buyer/utils';

import { StatusBadge } from './status-badge';

type DivisionDividerProps = {
  division: BindedPromoData[number];
  isSubmitted?: boolean;
  divIdx: number;
  deliveryOrder?: OrderWithDeliveryOrders;
};

export const DivisionDivider = ({
  division,
  isSubmitted,
  divIdx,
  deliveryOrder: _deliveryOrder,
}: DivisionDividerProps) => {
  if (!division.divider) {
    return null;
  }

  const displayStatus = division.status;

  return (
    <Tr key={`divider-${divIdx}`}>
      <Td colSpan={4}>
        <Flex
          gap="4"
          bg="#0941A8"
          color="white"
          p={2}
          fontWeight="bold"
          rounded="xl"
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex gap="4" alignItems="center">
            <Text textTransform="uppercase">
              {`${division.divider}${
                isSubmitted ? ` - ${division.sub_po_number}` : ''
              }`}
            </Text>
            <StatusBadge
              status={displayStatus}
              reason={division.reason}
              sapNote={division.sap_note}
            />
          </Flex>
        </Flex>
      </Td>
    </Tr>
  );
};
